
import { defineComponent, ref, computed } from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default defineComponent({
  name: "merchant-fieldmap-modal",
  components: {},
  props: {
    formType: String,
    dataFields: Array,
    isLoading: Boolean,
    isCompleted: Boolean,
  },
  watch: {
    dataFields() {
      this.reset = 0;
    },
    isLoading(val) {
      this.loading = val;
    },
    isCompleted(val) {
      if (val) {
        this.completedImport();
      }
    },
  },
  data: function () {
    return {
      options: {
        draggable: ".item",
        dropzone: ".dropzone",
      },
    };
  },
  methods: {
    droppingStop: function (e) {
      var zoneType = e.dropzone.attributes["type"].value;
      var index = e.dropzone.attributes["data-index"].value;
      var fieldName = e.dragEvent.source.attributes["data-fieldname"].value;

      if (zoneType == "group") {
        if (this.groups[index].item == "") {
          var prev_groups = this.groups.filter(
            (group) => group.item === fieldName
          );
          if (prev_groups.length > 0) prev_groups[0].item = "";
          this.groups[index].item = fieldName;

          prev_groups = this.groups4Import.filter(
            (group) => group.item === fieldName
          );
          if (prev_groups.length > 0) prev_groups[0].item = "";
        }
      } else {
        var has_groups = this.groups.filter(
          (group) => group.item === fieldName
        );
        if (has_groups.length > 0) has_groups[0].item = "";

        has_groups = this.groups4Import.filter(
          (group) => group.item === fieldName
        );
        if (has_groups.length > 0) has_groups[0].item = "";
        this.groups4Import[index].item = fieldName;
      }
    },
  },
  setup(props, context) {
    const fieldMapModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const reset = ref(0);
    const groups = ref([
      {
        name: "mid_number",
        subLabel: "(Mid number)",
        required: true,
        item: "",
      },
      {
        name: "processor_id",
        subLabel: "(Processor)",
        item: "",
      },
      {
        name: "corp_name",
        subLabel: "(Corp name)",
        required: true,
        item: "",
      },
      {
        name: "dba_name",
        subLabel: "(DBA name)",
        required: true,
        item: "",
      },
      {
        name: "mid_descriptor",
        subLabel: "(Mid descriptor)",
        required: true,
        item: "",
      },
      {
        name: "crm_uuid",
        subLabel: "(CRM UUID)",
        item: "",
      },
      {
        name: "gw_uuid",
        subLabel: "(GW UUID)",
        item: "",
      },
      {
        name: "mcc",
        subLabel: "(MCC)",
        item: "",
      },
      {
        name: "logo_url",
        subLabel: "(Logo URL)",
        item: "",
      },
      {
        name: "product_name",
        subLabel: "(Product name)",
        item: "",
      },
      {
        name: "product_description",
        subLabel: "(Product description)",
        item: "",
      },
      {
        name: "product_url",
        subLabel: "(Product Url)",
        item: "",
      },
      {
        name: "product_price",
        subLabel: "(Product price)",
        item: "",
      },
      {
        name: "fulfill_type",
        subLabel: "(Fulfill type)",
        item: "",
      },
      {
        name: "url",
        subLabel: "(Checkout Url)",
        item: "",
      },
      {
        name: "url_phone",
        subLabel: "(Phone number)",
        item: "",
      },
      {
        name: "email",
        subLabel: "(Email)",
        item: "",
      },
      {
        name: "terms_url",
        subLabel: "(terms url)",
        item: "",
      },
      {
        name: "cancel_url",
        subLabel: "(cancel url)",
        item: "",
      },
      {
        name: "contact_url",
        subLabel: "(contact url)",
        item: "",
      },
      {
        name: "refund_url",
        subLabel: "(refund url)",
        item: "",
      },
      {
        name: "merchant_type",
        subLabel: "(Merchant type)",
        required: true,
        item: "",
      },
    ]);
    // eslint-disable-next-line
    const groups4Import = ref<any>([]);

    const getGroups4Import = computed(() => {
      if (!props.dataFields) {
        return [];
      }

      initGroups();
      initImportFields(props.dataFields);

      if (reset.value > 0) {
        return groups4Import.value;
      }
      return autoAlign();
    });

    const initGroups = () => {
      groups.value.map((group) => {
        group.item = "";
      });
      groups.value.sort((a, b) => (a.name > b.name ? 1 : -1));
    };

    const initImportFields = (importfields) => {
      const fields = [...importfields];
      groups4Import.value.splice(0);
      fields.map((field) => {
        groups4Import.value.push({ name: field, item: field });
      });
      groups4Import.value.sort((a, b) => (a.name > b.name ? 1 : -1));
    };

    const autoAlign = () => {
      groups.value.map((group) => {
        const field = groups4Import.value.find(
          (target) => target.name === group.name
        );
        if (field) {
          group.item = field.name;
          field.item = "";
        }
      });

      return groups4Import.value;
    };

    const validate = () => {
      const missingFields = groups.value.filter(
        (group) => group.required === true && group.item == ""
      );
      if (missingFields.length > 0) {
        let errorMsg = "please fill in the required field: ";
        for (let i = 0; i < missingFields.length; i++) {
          if (i !== missingFields.length - 1) {
            errorMsg +=
              missingFields[i].name.charAt(0).toUpperCase() +
              missingFields[i].name.slice(1) +
              ", ";
          } else {
            errorMsg +=
              missingFields[i].name.charAt(0).toUpperCase() +
              missingFields[i].name.slice(1);
          }
        }

        Swal.fire({
          text: errorMsg,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });

        return false;
      }

      return true;
    };

    const handleFieldMap = () => {
      if (validate()) {
        context.emit("on-handle-field-map", groups.value);
      }
    };

    const resetFieldMap = () => {
      reset.value++;
    };

    const completedImport = () => {
      hideModal(fieldMapModalRef.value);
    };

    return {
      groups,
      getGroups4Import,
      groups4Import,
      reset,
      handleFieldMap,
      resetFieldMap,
      validate,
      loading,
      fieldMapModalRef,
      completedImport,
      initGroups,
      initImportFields,
    };
  },
});
